//@ts-checks
import { createApp } from "vue";
//
import htmlNew from "./customBrandname.html";
import b2bTypeahead from "./composant/b2bTypeahead";
import { toDate, may } from "./composant/b2bLangue";
import cardUsers from "./composant/cardUsers";
import { $$Dic, bootbox } from "../B2bTools";

function nbe(object) {
	let nb = 0;
	for (let key in object) if (object[key]) nb++;
	return nb;
}
const jsNew = ({
	url: function (echangeur) {
		echangeur.addAction('b2b.linelist.edit', echangeur.hash, '', 'form');
	},
	onLoad: async function (echangeur) {
		const THIS = this;
		//
		const $$dic = new $$Dic(echangeur.form.$$dic);
		//
		const defaultsaisie = echangeur.form;
		if (!defaultsaisie.parent) defaultsaisie.parent = echangeur.hash.duplicate;
		//
		//
		const app = createApp({
			components: {
				"type-ahead": b2bTypeahead,
				'card-users': cardUsers
			},
			data: function () {
				//
				return {
					//
					reg1: defaultsaisie.regroupment.level1.v,
					reg2: defaultsaisie.regroupment.level2.v,
					//
					linelist: defaultsaisie,
					saisie: {
						brandnames: echangeur.form.brandnames || [],
						category: echangeur.form.category || '...',
						customtitle: echangeur.form.customtitle,
						team: echangeur.form.team || "",
						orderdepartment: echangeur.form.orderdepartment || "",
					},
					errors: {},
				}
			},
			computed: {

			},
			methods: {
				cancel: function () {
					THIS.fin();
				},
				categoryAdd() {
					this.categorytxt = this.categorytxt.trim();
					if (this.categorytxt && !this.categoryList.includes(this.categorytxt)) {
						this.categoryList.push(this.categorytxt);
						this.saisie.category = this.categorytxt;
					}
					this.categorytxt = "";
				},
				may(key) {
					return may(key);
				},
				toDate: function (a) {
					return toDate(a);
				},
				toBrandname: function (k) {
					return $$dic.brandname(k).v;
				},
				brandGetbuyer: function (k) {
					const doc = $$dic.brandname(k);
					const orderdepartment = this.saisie.orderdepartment;

					//console.log(k, orderdepartment)
					//console.log(doc)
					if (doc.orderdepartments) {
						//console.log(doc.orderdepartments)
						const a = doc.orderdepartments.find(u => u.orderdepartment === orderdepartment);
						if (a) {
							return a.buyers.map( k=> $$dic.utilisateur(k) )
						} 
					} else {
					}
					return [];
				},
				toBrandObject: function (k) {
					return $$dic.brandname(k);
				},
				toBuyer(k) {
					return $$dic.utilisateur(k);
				},
				pretenom(buyer) {
					if (!may("PRETENOM")) return false;
					if (buyer.profil == "dmk-buy") return true;
					return false;
				},
				disable(buyer) {
					const utilisateur = buyer;
					const thisVue = this;
					//console.log("disable utilisateur", utilisateur)
					utilisateur
					bootbox.confirm(
						{
							title: 'Disable account',
							message: `Disable <b> ${utilisateur.email} </b> account ?`
						},
						async function () {
							let result = await THIS.rest("user.disable", { k: utilisateur.k, email: utilisateur.email }, {});
							utilisateur.status = result.status;
							utilisateur.email = "iuiouiouio"
							utilisateur.caca = "boum"
						})
					return false;
				},
				enable(buyer) {
					const utilisateur = buyer;
					const thisVue = this;
					//console.log("enable utilisateur", utilisateur)
					bootbox.confirm(
						{
							title: 'Enable account',
							message: `Enable <b> ${utilisateur.email} </b> account ?`
						},
						async function () {
							// thisVue.user.actie = true;
							let result = await THIS.rest("user.enable", { k: utilisateur.k, email: utilisateur.email }, {});
							utilisateur.status = result.status;
							//thisVue.sendmailactivation()
						})
					return false;
				},
				connectas(buyer) {
					const url = "" + window.location;
					const a = url.split("?")[0];
					const b = a.split("#")[0];
					const c = b + "?client=" + encodeURI(buyer.k) + "#";
					window.location.assign(c);
				},
				fin: function () {
					THIS.fin();
				},
				toDate: function (date) {
					return toDate(date);
				},
				async brandSelect(item) {
					// console.log(item)
					if (this.saisie.brandnames.indexOf(item._id) == -1) {
						const brandnames = this.saisie.brandnames.map(u => u);
						brandnames.unshift(item._id);
						//
						const doc = await THIS.rest("b2b.brandname.edit", { _id: item._id });
						$$dic.add(doc.$$dic);
						delete doc.$$dic;
						$$dic.add({ brandname: [doc] });
						//
						//
						const form = {
							_id: this.linelist._id,
							brandnames: brandnames,
						}
						let data = await THIS.rest("b2b.linelistcustom.save", {}, form);
						if (data && data.ok) {
							this.saisie.brandnames = brandnames;
						};
					}
				},
				async brandRemove(_id) {

					const thisparent = this

					bootbox.confirm(
						{
							title: 'Remove Brand Name',
							message: 'Are you sure to remove ?'
						},
						async function () {

							const brandnames = thisparent.saisie.brandnames.filter(el => { return (el != _id) });
							const form = {
								_id: thisparent.linelist._id,
								brandnames: brandnames,
							}

							let data = await THIS.rest("b2b.linelistcustom.save", {}, form);
							if (data && data.ok) {
								thisparent.saisie.brandnames = brandnames;
							}

						})

				},

				brandTypeahead() {
					return async function (key) {
						let v = await THIS.rest("b2b.brandname.typeahead", { k: key, limit: 10 })
						let retour = [];
						v.forEach(element => {
							retour.push({ _id: element._id, v: element.v, clients: element.clients, orderdepartments: element.orderdepartments, vth: element.v });
						});
						return retour;
					}
				},
				brandTypeaheadRep() {
					return async function (key) {
						let v = await THIS.rest("b2b.brandname.typeaheadRep", { k: key, limit: 10 })
						let retour = [];
						v.forEach(element => {
							retour.push({ _id: element._id, v: element.v, clients: element.clients, orderdepartments: element.orderdepartments, vth: element.v });
						});
						return retour;
					}
				},


				// save: async function () {
				// 	this.errors = {};
				// 	let form = {
				// 		_id: this.linelist._id,
				// 		parent: this.linelist.parent,
				// 		team: this.saisie.team,
				// 		customtitle: this.saisie.customtitle,
				// 		category: this.saisie.category,
				// 		brandnames: this.saisie.brandnames,
				// 		orderdepartment: this.saisie.orderdepartment,
				// 	}



				//     if (!form.orderdepartment ) this.errors.orderdepartment = true;

				//     if (!nbe(this.errors)) {
				//         let data = await THIS.rest("b2b.linelistcustom.save", {}, form);
				// 		if (data && data.ok) THIS.fin();
				//     }



				// },
			},
			mounted() {

			}
		});
		app.mount(THIS.c$('._vueChargement')[0]);
	},
	loader: function (echangeur) {

	},

});


export default {
	customBrandname: { js: jsNew, html: htmlNew }
};
